import React from "react";
import { Grid } from "@material-ui/core";
import { DateSelect } from "Components/Shared/DateSelect/DateSelect";
import { usePayPeriodEndDates } from "Hooks/usePayPeriodEndDates";

export interface PayPeriodEndDateSelectProps {
  date: string;
  onChangeDate: (newDate: string) => void;
}

export const PayPeriodEndDateSelect = ({ date, onChangeDate }: PayPeriodEndDateSelectProps) => {
  const { endDates } = usePayPeriodEndDates();

  return (
    <Grid item xs={5} container alignItems="center" justify="flex-start">
      <Grid item xs={5}>
        Pay Period End Date
      </Grid>
      <Grid item xs={7} >
        <DateSelect
          date={date}
          dates={endDates || []}
          onChangeDate={onChangeDate}
          includeSelectAllOption
        />
      </Grid>
    </Grid>
  );
};
